import { render } from "./DatasetCreateModal.vue?vue&type=template&id=53c22650&scoped=true"
import script from "./DatasetCreateModal.vue?vue&type=script&lang=js"
export * from "./DatasetCreateModal.vue?vue&type=script&lang=js"

import "./DatasetCreateModal.vue?vue&type=style&index=0&id=53c22650&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c22650"]])

export default __exports__